<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<div class="img_container">
<img alt="image" src="images/fm.jpg"/>
</div>
<p class="caption">F<span class="smallcaps">RANKLIN</span> D. R<span class="smallcaps">OOSEVELT</span></p>
<p class="noindent1"><em class="italic">From a dry point by Garden Grant L</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Fm01.vue?35816e6a